import LocalizedStrings from 'localized-strings';

import { TeamMembersRequestStatus } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    amountLabel: 'Amount',
    approveRequest: 'Approve',
    callouts: {
      processing: {
        description:
          'The transfer is usually processed instantly but can take up to 24 hours.',
        title: 'Processing transfer',
      },
    },
    emailLabel: 'E-mail',
    exceededQuotaDescription:
      'The cost of sending this transfer is **{fees} excluding VAT.**',
    exceededQuotaTitle: 'Transfer fees',
    executionDateLabel: {
      [TeamMembersRequestStatus.Processed]: 'Requested on',
      [TeamMembersRequestStatus.Pending]: 'Requested on',
      [TeamMembersRequestStatus.Approved]: 'Requested on',
      [TeamMembersRequestStatus.Completed]: 'Executed on',
      [TeamMembersRequestStatus.Rejected]: 'Rejected on',
      [TeamMembersRequestStatus.Canceled]: 'Canceled on',
    },
    insufficientFunds: 'Your account balance is insufficient',
    newBankTransferRecipient:
      'The recipient will be saved if you approve the transfer',
    recipientLabel: 'Recipient',
    refuseRequest: 'Refuse',
    sendConfirmationEmailLabel:
      'Once the transfer has been approved, the recipient will be informed by e-mail.',
    sendConfirmationEmailTitle: 'Send a transfer confirmation by e-mail',
    strongAuthSidebarDescription:
      'Sensitive operations such as transfers require your passcode.',
    transactionOut: 'Transaction out',
    userLabel: 'Label',
  },
  fr: {
    amountLabel: 'Montant',
    approveRequest: 'Approuver',
    emailLabel: 'E-mail',
    exceededQuotaDescription:
      'L’envoi de ce virement est facturé **{fees} HT.**',
    exceededQuotaTitle: 'Frais de virement',
    executionDateLabel: {
      [TeamMembersRequestStatus.Processed]: 'Demandé le',
      [TeamMembersRequestStatus.Pending]: 'Demandé le',
      [TeamMembersRequestStatus.Approved]: 'Demandé le',
      [TeamMembersRequestStatus.Completed]: 'Exécuté le',
      [TeamMembersRequestStatus.Rejected]: 'Rejeté le',
      [TeamMembersRequestStatus.Canceled]: 'Annulé le',
    },
    insufficientFunds: 'Le solde de votre compte est insuffisant',
    newBankTransferRecipient:
      'Le bénéficiaire sera enregistré si vous approuvez le virement',
    recipientLabel: 'Bénéficiaire',
    refuseRequest: 'Refuser',
    sendConfirmationEmailLabel:
      'Une fois le virement approuvé, le destinataire en sera informé par e-mail.',
    sendConfirmationEmailTitle:
      'Envoyer une confirmation du virement par e-mail',
    strongAuthSidebarDescription:
      'Les opérations sensibles comme les virements nécessitent votre code secret.',
    transactionOut: 'Virement sortant',
    userLabel: 'Libellé',
  },
} as const);

export default locales;
